import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { sendMessageError, sendMessageSuccess } from '../../actions/toast';
import { addTypeRisque } from '../../actions/typesRisque';

export default class AddTypeRisque extends React.Component {
    state = {
        nom: '',
    };

    handleInput = (identifiant, e) => {
        this.setState({
            [identifiant]: e.target.value,
        });
    };

    handleSubmit = () => {
        addTypeRisque(this.state.nom)
            .then(() => {
                sendMessageSuccess("Type de risque bien ajouté !");
                this.props.history.push("/typesRisque");
            })
            .catch(error => sendMessageError(error));
    };

    render() {
        const { nom } = this.state;

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        Ajouter un type de risque
                    </h1>
                    <ol className="breadcrumb">
                        <li>
                            <Button onClick={() => this.props.history.push("/typesRisque")}>
                                <i className="fa fa-dashboard"></i>
                                Types de risques
                            </Button>
                        </li>
                        <li className="active">
                            Ajouter un type de risque
                        </li>
                    </ol>
                </section>
                <section className="content">
                    <div className="row">
                        <div className="col-md-6 col-md-offset-3">
                            <div className="box box-primary">
                                <div className="box-header with-border">
                                    <h3 className="box-title">Informations</h3>
                                </div>
                                <form role="form">
                                    <div className="box-body">
                                        <div className="form-group">
                                            <TextField
                                                label="Nom"
                                                fullWidth={true}
                                                value={nom}
                                                onChange={e => this.handleInput("nom", e)}
                                            />
                                        </div>
                                    </div>

                                    <div className="box-footer text-center">
                                        <Button
                                            onClick={this.handleSubmit}
                                            color="primary"
                                        >
                                            Enregistrer
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
